/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import Modal from "../../components/Genericos/Modal/Modal";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import Loading from "../../components/Genericos/Loading/Loading";
import GrupoFamiliarTxt from "./GrupoFamiliarTxt";
import { IonSpinner } from "@ionic/react";
import {
  wsGetGrupoFamiliar,
  wsGetTiposParentesco,
} from "../../context/Actions/grupoFamiliar/grupoFamiliar";
import CardGrupoFamiliar from "../../components/Perfil/CardGrupoFamiliar/CardGrupoFamiliar";
import { showModal } from "../../context/Actions/modal/modal";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { GlobalContext } from "../../../global/context/Provider";
import "./GrupoFamiliar.css";
import { motion } from "framer-motion";
import {
  container,
  dots,
  pageContainerVariants,
} from "global/utils/cardAnimation";
import { getListaFamiliares } from "_+_Portal/context/Actions/listaFamiliares/listasFamiliares";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const GrupoFamiliar = () => {
  const {
    grupoFamiliarState,
    grupoFamiliarDispatch,
    modalState,
    modalDispatch,
    ayudaDispatch,
    listaFamiliaresDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { toasterState, toasterDispatch } = useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [familiaresList, setFamiliaresList] = useState(null);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };
  let data = sessionStorage.getItem("familiares");

  useEffect(() => {
    obtenerFamiliares();
  }, []);

  // Sincronizar lista local con el contexto cuando se vincula/desvincula/edita desde los modales
  useEffect(() => {
    const data = grupoFamiliarState?.grupoFamiliar?.data;
    if (Array.isArray(data)) {
      setFamiliaresList(data);
    }
  }, [grupoFamiliarState?.grupoFamiliar?.data]);

  const obtenerFamiliares = () => {
    wsGetGrupoFamiliar(true, nextStep)(grupoFamiliarDispatch);
    getListaFamiliares(true)(listaFamiliaresDispatch);
  };

  const nextStep = (isCorrect, data) => {
    if (isCorrect) {
      setFamiliaresList(data);
    } else {
      showToaster(
        {
          texto: "Error al cargar el grupo familiar",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };
  // abrir modal para agregar familia
  // AF = Agregar Familiar
  const handleModalShowAF = () => {
    wsGetTiposParentesco((isCorrect, data) => {
      if (isCorrect) {
        showModal(
          "Perfil/ModalAddFamiliar/ModalAddFamiliar",
          {},
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        showToaster(
          {
            tipo: "danger",
            texto: "No se han podido cargar los tipos de parentesco.",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    })(grupoFamiliarDispatch);
  };

  useEffect(() => {
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }, 250);
  }, []);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <Loading
        dataLoading={grupoFamiliarState.grupoFamiliar.loading}
        color="c-white"
        descripcion="Cargando Grupo Familiar..."
      />
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Grupo Familiar"} />

      {/* <MultitabMobileMisMedicos /> */}
      <div className="ptur-bodyContainer-grupoFamiliar">
        <div className="ptur-mainSidebar">
          <Sidebar />
        </div>
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"mismed-body-grupoFamiliar"}
        >
          <div className="ptur-grupoFamiliar-tituloLabo rb24b">
            <div className="ptur-grupoFamiliar-titulo-boton">
              <GrupoFamiliarTxt />
              <div className="ptur-grupoFamiliar-boton-container">
                <button
                  // onClick={onBuscarTurnosClick}
                  className="ptur-grupoFamiliar-botonSiguiente bgc-primary c-white rb18m"
                  disabled={grupoFamiliarState.grupoFamiliar.loading}
                  onClick={handleModalShowAF}
                >
                  {grupoFamiliarState.grupoFamiliar.loading ? (
                    <span className="ptur-grupoFamiliar-loading">
                      <IonSpinner name="lines-small" />
                    </span>
                  ) : (
                    "Agregar un familiar"
                  )}
                </button>
              </div>
            </div>
            <hr className="ptur-grupoFamiliar-lineaSeparadora" />
          </div>
          <motion.ul
            key={familiaresList?.length}
            className="ptur-grupoFamiliar-cardsContainer"
            variants={container(0.1)}
            initial="hidden"
            animate="visible"
          >
            {Array.isArray(familiaresList) &&
              familiaresList.map((item, index) => (
                <motion.li
                  key={item.id}
                  className="itemCardGF"
                  variants={dots()}
                >
                  <React.Fragment key={index}>
                    <div className="ptur-misMedicos-body">
                      <CardGrupoFamiliar
                        item={item}
                        derecho_editarPerfil={
                          item.tipoDerecho
                            ? item.tipoDerecho.edicionPerfil
                            : ""
                        }
                        derecho_manejoTurnos={
                          item.tipoDerecho
                            ? item.tipoDerecho.manejoTurnos
                            : ""
                        }
                        derecho_verResultados={
                          item.tipoDerecho
                            ? item.tipoDerecho.verResultados
                            : ""
                        }
                        derecho_editarPerfil_otros={
                          item.tipoDerechoMe
                            ? item.tipoDerechoMe.edicionPerfil
                            : ""
                        }
                        derecho_manejoTurnos_otros={
                          item.tipoDerechoMe
                            ? item.tipoDerechoMe.manejoTurnos
                            : ""
                        }
                        derecho_verResultados_otros={
                          item.tipoDerechoMe
                            ? item.tipoDerechoMe.verResultados
                            : ""
                        }
                        // obtenerFamiliares={obtenerFamiliares}
                      />
                    </div>
                    <span>{data}</span>
                  </React.Fragment>
                </motion.li>
              ))}
          </motion.ul>
        </motion.div>
      </div>
    </React.Fragment>
  );
};
export default GrupoFamiliar;
